import { render, staticRenderFns } from "./addOkrWork.vue?vue&type=template&id=18dd449e&scoped=true&"
import script from "./addOkrWork.vue?vue&type=script&lang=js&"
export * from "./addOkrWork.vue?vue&type=script&lang=js&"
import style0 from "./addOkrWork.vue?vue&type=style&index=0&id=18dd449e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dd449e",
  null
  
)

component.options.__file = "addOkrWork.vue"
export default component.exports